// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"a3418994","357":"b97a9061","523":"67e693f2","729":"b04741ee","887":"25bdbea4","908":"49abc3dc","927":"2dbcc2b8","960":"fcac0096"}[chunkId] + ".js";
};